import { render, staticRenderFns } from "./DePara.vue?vue&type=template&id=5f2fa56a&scoped=true"
import script from "./DePara.vue?vue&type=script&lang=js"
export * from "./DePara.vue?vue&type=script&lang=js"
import style0 from "./DePara.vue?vue&type=style&index=0&id=5f2fa56a&prod&lang=scss&scoped=true"
import style1 from "./DePara.vue?vue&type=style&index=1&id=5f2fa56a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2fa56a",
  null
  
)

export default component.exports